// Copyright 2025 - Hewlett Packard Enterprise Company
import PropTypes from 'prop-types';
import { Anchor } from 'grommet';
import { useContext } from 'react';
import { HelpContext } from '../../providers/HelpProvider';
import useFlags from '../../hooks/useFlags';

export default function LearnMoreLink({
  alignSelf = 'start',
  topicId,
  useContextualHelp = false,
  children,
  ...rest
}) {
  const flags = useFlags();
  const learnMoreContextualHelpFlag =
    flags.T_20250312_18961_CONTEXTUAL_HELP_LEARN_MORE_LINKS_BOOL();
  const { setContentId, setIsHelpOpen } = useContext(HelpContext);

  const onClickLearnMore = contentId => {
    if (learnMoreContextualHelpFlag && useContextualHelp) {
      dispatchEvent(
        new CustomEvent('context-help', {
          detail: { topic: contentId, pin: false },
        }),
      );
    } else {
      setContentId(contentId);
      setIsHelpOpen(true);
    }
  };

  return (
    <Anchor
      alignSelf={alignSelf}
      href="#"
      onClick={() => onClickLearnMore(topicId)}
      {...rest}
    >
      {children}
    </Anchor>
  );
}

LearnMoreLink.propTypes = {
  topicId: PropTypes.string.isRequired,
  useContextualHelp: PropTypes.bool,
};
